import styled from 'styled-components';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

interface SectionNavContainerProps extends StyledComponentsPropWithTheme {
  isMobile?: boolean;
}

export const SectionNavContainer = styled.div<SectionNavContainerProps>`
  & nav {
    padding-inline-start: ${({ theme }) => theme.spacing.small.default};
  }
`;
